<template>
  <div class="hello">
    <div class="bod">
      <div class="foote" ref="foote">
        <div class="messageTop">
          <span>核对订单信息</span>
        </div>
        <div class="address">
          <div class="addressTitle">
            <span>收货人信息</span>
          </div>
          <div class="addressList">
            <div class="addList" :class="{shop_active:item.is_default == 1 ||item.isActive }" v-for="(item,index) in addList" :key="index" @click="addressE(index)">
              <div class="addTop">
                <div class="left">
                  <span>{{item.name}}</span>
                </div>
                <div class="right">
                  <span>{{item.mobile.substr(0,3)+ '******' + item.mobile.substr(8)}}</span>
                </div>
              </div>
              <div class="content">
                <span>
                  {{item.detail}}
                </span>
              </div>
              <div class="caozuo">
                <span @click="editEvent(item.address_id)">编辑</span>
                <span style="color: #E83D3D;" @click="del(item.address_id)">删除</span>
              </div>
            </div>

            <div class="add_address" @click="addressEve()">
              <div class="uploadImage">
                <div class="upload">
                  <img src="../assets/image/uploadAdd.png" alt="">
                </div>
                <div class="add_title">
                  <span>收货地址</span>
                </div>
              </div>
            </div>


          </div>
        </div>

        <div class="shopMessage">
          <div class="shop_top">
            <div class="shop_left">
              <span>确认商品</span>
            </div>
          </div>
          <div class="shop_tab">
            <div class="kong"></div>
            <div class="shop_name">
              <span>商品名称</span>
            </div>
            <div class="shop_name">
              <span>价格（元）</span>
            </div>
            <div class="shop_name">
              <span>数量</span>
            </div>
            <div class="shop_all">
              <span>小计</span>
            </div>
          </div>
          <div class="shop_list" v-for="(item,index) in goodsList" :key="index">
            <div class="shop_pic">
              <div class="goods_pic">
                <img :src="item.spec_pic" alt="">
              </div>
            </div>
            <div class="shop_name_list">
              <div class="shop_title">
                <span>{{item.goods_title}}</span>
              </div>
              <div class="shop_desc">
                <span>套餐：{{item.spec_name}}</span>
              </div>
            </div>
            <div class="shop_pic">
              <span style="color:rgba(235,61,69,1);">
                {{item.price}}
              </span>
            </div>
            <div class="shop_pic">
              <span>{{item.goods_num}}</span>
            </div>
            <div class="shop_al_listl">
              <span style="color:rgba(235,61,69,1);" v-if="isCar == 0">
                <!-- {{item.total_price}} -->
                {{(item.price * item.goods_num).toFixed(2)}}
              </span>
              <span style="color:rgba(235,61,69,1);" v-else>
                {{item.total_price}}
              </span>
            </div>
          </div>
        </div>


        <div class="pay">
          <div class="pay_top">
            <div class="pay_right">
              <div class="pay_title" >
                <span>已选商品{{goodsList.length}}件，合计：¥{{all_price}}</span>
              </div>
              <div class="pay_fee">
                <span>运费： ¥ {{fee_price}}</span>
              </div>
            </div>
          </div>
          <div class="pay_body">
            <div class="body_right">
              <div class="pay_price">
                应付 <span class="price">￥{{(parseFloat(all_price) + parseFloat(fee_price)).toFixed(2)}}</span>
              </div>
              <div class="pay_user">
                <span>收件人：{{userName}} {{mobile.substr(0,3) + '*****' + mobile.substr(8)}}</span>
              </div>
              <div class="pay_address">
                <span>配送地址：{{province}} {{city}} {{area}} {{detail}}</span>
              </div>

              <div class="submitBtn" @click="goPayment()">
                <span>立即购买</span>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 300px;"></div>
      </div>
      <div class="mask" v-if="addressShow">
        <div class="add_infor">
          <div class="close" @click="closeEvent()">
            <img src="../assets/image/close.png" alt="">
          </div>
          <div class="addInfo_top">
            <span>{{addInfo}}</span>
          </div>
          <div class="label">
            <div class="addInfo_left">
              <span style="color:#E83C3C;">*</span>收货人:
            </div>
            <input type="text" v-model="form.name" class="myinput">
          </div>
          <div class="label">
            <div class="addInfo_left">
              <span style="color:#E83C3C;">*</span>手机号:
            </div>
            <input type="text" v-model="form.mobile" class="myinput">
          </div>
          <div class="label">
            <div class="addInfo_left">
              <span style="color:#E83C3C;">*</span>收货地区:
            </div>
            <div class="input">
              <v-distpicker :province="form.province" :city="form.city" :area="form.area" @province="onChangeProvince1"
                @city="onChangeCity" @area="onChangeArea"></v-distpicker>
            </div>
          </div>
          <div class="label">
            <div class="addInfo_left">
              <span style="color:#E83C3C;">*</span>详细地址:
            </div>
            <input type="text" v-model="form.detail" class="myinput">
          </div>
          <div class="default">
            <div class="select" @click="defulteEvent()">
              <img v-if="!selectDefult" src="../assets/image/selects.png" alt="">
              <img v-else src="../assets/image/selects_active.png" alt="">
            </div>
            <div class="title">
              <span>设置默认地址</span>
            </div>
          </div>

          <div class="submitB" @click="submit()">
            <span>保存</span>
          </div>
        </div>
      </div>

      <fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
    </div>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  import VDistpicker from 'v-distpicker'
  export default {
    components: {
      VDistpicker,
      fiex
    },
    data() {
      return {
        fixed: true,
        selectDefult: false,
        addressShow: false,
        addList: [],
        arr: [],
        all_price: 0,
        goodsList: [],
        userName: '',
        mobile: '',
        detail: '',
		addInfo:'新建收货地址',
        province: '',
        city: '',
        area: '',
        fee_price: 0,
        isCar:0,
        form: {
          name: '',
          mobile: '',
          province: '',
          city: '',
          area: '',
          detail: '',
          tag: '',
          is_default: 0
        }
      }
    },
    created() {
      this.ajaxFun();
      this.isCar = this.$route.query.isCar;
    },
    methods: {
      ajaxFun() {
        var data = {
          goodsJson: localStorage.getItem('carArr')
        }
        var that = this;
        this.$post('order/submit', data).then(res => {
          if(res.code == 200){
             res.data.defaultAddress.forEach(item=>{
               this.$set(item,'isActive',false);
             })
              this.addList = res.data.defaultAddress;
              this.goodsList = res.data.goods;
              // this.goodsList.forEach(item=>{
              //   // item.fee_price += parseInt(item.fee_price);
              //   console.log(parseInt(item.fee_price))
              // })
              this.fee_price = res.data.fee_price.toFixed(2);
              // this.all_price = localStorage.getItem('all_price')
               if(this.isCar == 0){
                 this.goodsList.forEach(item=>{
                   that.all_price = (item.goods_num * item.price).toFixed(2)
                 })
               }else{
                 this.all_price = this.goodsList.reduce((count,item) => count + parseFloat(item.total_price),0).toFixed(2);
               }

              this.addList.forEach(item => {
                if (item.is_default == 1) {
                  this.userName = item.name;
                  this.mobile = item.mobile;
                  this.detail = item.detail;
                  this.province = item.province;
                  this.city = item.city;
                  this.area = item.area;
                }
              })
          }else{
            this.$router.go(-1);
          }

        })
      },

      addressE(index){
        this.addList.forEach(item=>{
          item.isActive = false;
          item.is_default = 0;
        })

        this.addList[index].isActive = true;

      },
      defulteEvent() {
        this.selectDefult = !this.selectDefult;
      },
      addressEve() {
        this.addressShow = true;
      },
      closeEvent() {
        this.addressShow = false;
      },
      onChangeProvince1(e) {
        if (e.code != 'undefined') {
          this.form.province = e.value;
        }
      },
      onChangeCity(e) {
        if (e.code != 'undefined') {
          this.form.city = e.value;
        }
      },
      onChangeArea(e) {
        if (e.code != 'undefined') {
          this.form.area = e.value;
        }
      },
      goTop(){
        this.$refs.foote.scrollTop = 0;
      },
      // 删除收货地址
      del(id) {
        this.$post('useraddress/del', {
          id: id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功');
            this.ajaxFun();
          }
        })
      },
      // 添加收货地址
      submit() {
		  this.addInfo = '新建收货地址';
        if (this.selectDefult) {
          this.form.is_default = 1
        } else {
          this.form.is_default = 0;
        }
        this.$post('useraddress/add', this.form).then(res => {
          if (res.code == 200) {
            this.$message.success('添加成功');
            this.addressShow = false;
            this.form = {};
            this.ajaxFun();
          }
        })
      },
      editEvent(id) {
		this.addInfo = '编辑收货地址';
        this.$fetch('useraddress/detail', {
          id: id
        }).then(res => {
          if (res.code == 200) {
            this.form = res.data;
            this.form.id = res.data.address_id;
            if (res.data.is_default == 1) {
              this.selectDefult = true;
            } else {
              this.selectDefult = false;
            }
            this.addressShow = true;
          }
        })
      },
      goPayment() {
        let addRess = 0;
        this.addList.forEach(item => {
          if (item.is_default == 1) {
            addRess = item.address_id
          }else{
            if(item.isActive){
              addRess = item.address_id;
            }
          }
        })
        var data = {
          goodsJson: localStorage.getItem('carArr'),
          address_id: addRess,
          is_cart: 1,
          pay_type: 1
        }
        this.$post('order/create', data).then(res => {
          localStorage.setItem('detail', JSON.stringify(res.data));
          if(res.data.order_id){
            this.$router.push({
              path: '/Cashier',
              query:{
                order_id:res.data.order_id,
                isCar:this.$route.query.isCar
              }
            })
          }else{

          }

        })

      }
    },
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/detail/information.css");
</style>



// WEBPACK FOOTER //
// src/pages/information.vue